import { Pipe, PipeTransform } from "@angular/core";
import { convertFiatToDefaultFiat, toCurrencyByFiatId } from "@helpers/tradable-convert";
import { Fiat } from "@models";
import { AccountService } from "@modules/account/services/account.service";
import { stripFunnyInput } from "@helpers/utils";
import { FiatService } from "@main-services/currency";

@Pipe({
	name: "euro_to_user_fiat",
	standalone: false
})
export class EuroToUserFiatPipe implements PipeTransform {
	public constructor(private readonly accountService: AccountService) {}

	public transform(balance: number, fiat: Fiat = this.accountService.getDefaultFiat()): number {
		return toCurrencyByFiatId(balance, fiat);
	}
}

@Pipe({
	name: "convert_fiat_to_default_fiat",
	standalone: false
})
export class ConvertFiatToDefaultFiat implements PipeTransform {
	public constructor(
		private readonly accountService: AccountService,
		private readonly fiatService: FiatService
	) {}

	public transform(value: number | string, fiatPid: string): number {
		value = stripFunnyInput(value);
		const fiatId = this.fiatService
			.getList()
			?.getValue()
			.find((fiat) => fiat.getPid() === fiatPid)
			?.getId();
		return convertFiatToDefaultFiat(
			this.fiatService.getItemById(fiatId),
			+value,
			this.accountService.getDefaultFiat()
		);
	}
}
